export enum PAGE_ID {
  FORECAST = 'FORECAST',
  COMPARE = 'COMPARE',
  RISK = 'RISK',
}

/**
 * Master表分类
 */
export enum EVALUATION_PERIOD {
  FULL_PERIOD = '全期',
  PREVIOUS_PERIOD = '上期',
  NEXT_PERIOD = '下期',
  ACTUAL_ONLY = '実績のみ',
  FORECAST_ONLY = '見込のみ',
  UP_TO_THIS_MONTH = '今月まで',
  THIS_MONTH_ONLY = '今月単月',
  LAST_WEEK_ONLY = '先週単週',
  // SPECIAL
  LAST_12WEEK_ACTUAL = '12週実績',
}

export enum DIMENSION {
  MONTH = 'monthly',
  WEEK = 'weekly',
  DAY = 'daily',
}

export enum COMPARE {
  SNAPSHOT_RATIO = 'snapshot',
  PLANNED_RATIO = 'plan',
  PREVIOUS_YEAR_RATIO = 'prev_year',
  PREVIOUS_MONTH_RATIO = 'prev_month',
  PERIOD_RATIO = 'period',
}

export enum SWITCH_VALUE {
  DIFFERENCE = '差',
  RADIO = '比',
}

export enum DATA_UNIT {
  // 円/台/人
  NONE = 1,
  // 千円
  THOUSAND = 1000,
  // パーセント
  PERCENTAGE = 0.01,
  // 百万円
  MILLION = 1000000,
}

export enum SHOW_TYPE {
  // 目标比
  RADIO = 'Radio',
  // 目标差
  DIFF = 'Diff',
  // 数值
  VALUE = 'Value',
}

export enum PERIOD {
  PREVIOUS = '上期',
  NEXT = '下期',
}

export enum FIELD_CATEGORY {
  KPI_DATA = 'kpi_data',
  DRILL_DOWN = 'drill_down',
  RISK_POTENTIAL = 'risk_potential',
}

export enum FIELD_IMPORTANT {
  LEVEL0 = 0,
  LEVEL1 = 1,
}

export const enum SORT_SHOW {
  NAME = 'name',
  TREND = 'trend',
  DEVIATION = 'deviation',
}
